var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowForwardBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5913 1.35796L24.63 9.1358C25.1233 9.61308 25.1233 10.3869 24.63 10.8642L16.5913 18.642C16.098 19.1193 15.2983 19.1193 14.805 18.642C14.3117 18.1647 14.3117 17.3909 14.805 16.9136L20.6873 11.2222H2.26316C1.56554 11.2222 1 10.675 1 10C1 9.32502 1.56554 8.77783 2.26316 8.77783H20.6873L14.805 3.08637C14.3117 2.60909 14.3117 1.83525 14.805 1.35796C15.2983 0.880678 16.098 0.880678 16.5913 1.35796Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForwardBold);
export default __webpack_public_path__ + "static/media/arrow-forward-bold.451958854da9b826afea828a8c54723d.svg";
export { ForwardRef as ReactComponent };